<template>
  <BasePaymentForm
    class="custom-payment-form"
  >
    <template #body>
      <div class="icon form-group mt-2 mb-1 text-danger">
        <i class="fas fa-exclamation-circle mb-2"/>
        <span>
          {{ $t('apps.payment.message.paymentfailedheader') }}
        </span>
      </div>
      <div class="summary form-group mt-3 mb-0">
        <div class="section">
          {{ $t('apps.payment.message.paymentfaileddetail') }}
        </div>
      </div>
    </template>
    <template #footer-actions>
      <BaseButton
        :text="$t('button.gotohomepage')"
        :className="`btn-web`"
        @click="onClickNext"
      />
    </template>
  </BasePaymentForm>
</template>

<script>
export default {
  props: {
    transaction: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    onClickNext () {
      this.$emit('next')
    },
  },
}
</script>

<style scoped>
.custom-payment-form >>> .form {
  max-width: 494px;
  font-size: 14px;
}

.icon {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.icon i {
  font-size: 64px;
}

.icon span {
  font-size: 18px;
}

.billing {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.summary {
  display: flex;
  flex-direction: column;
  color: #999696;
  padding-left: 30px;
  padding-right: 30px;
}

.summary .section {
  display: flex;
  justify-content: space-between;
}

.download-btn {
  color: #999696;
  text-decoration: underline;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/payment/PaymentFail.vue